import React from "react";
import "./App.css";
import Repo from "./Utility/Repo";
import { createContext, useCallback, useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { MemoizedFooter } from "./Layout/Footer";
import FooterSmall from "./Layout/FooterSmall";
import { MemoizedHeader } from "./Layout/Header";
import Body from "./Layout/Body";
import Sidebar from "./Layout/Sidebar";
import { useCookies } from "react-cookie";
import jwt_decode from "jwt-decode";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { TokenContext } from "./Components/TokenContext";
import LabelsLoader from "./Utility/labelsLoader";
import BackButtonHandler from "./Components/BackButtonHandler";

function App({ title = "Titolo Predefinito" }) {
  const [cookies] = useCookies();
  const [apiToken] = useState(cookies.api_token);
  const [user, setUser] = useState();
  const [isLogged, setIsLogged] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [userStatus, setUserStatus] = useState(false);
  const [userData, setUserData] = useState(false);
  const [userDataStatus, setUserDataStatus] = useState(true);
  const [userISEEValid, setUserISEEValid] = useState(true);
  const [operator, setOperator] = useState(false);
  const [delegate, setDelegate] = useState(false);
  const [citizen, setCitizen] = useState(false);
  const [subfolder, setSubFolder] = useState(process.env.PUBLIC_URL);
  const sidebarMenuEnabled =
    String(process.env.REACT_APP_SIDEBAR_MENU || "").toLowerCase() === "true";
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);
  const toggleSidebar = useCallback(
    () => setSidebarOpen((open) => !open),
    []
  );

  const labels = LabelsLoader();

useEffect(() => {
  // 1) Se ho un api_token nei cookie e non ho ancora settato userData
  if (cookies.api_token && !userData) {
    try {
      const decodedCookie = jwt_decode(cookies.api_token);
      setUser(decodedCookie.FullName);
      setUserData(true);
    } catch (err) {
      console.error("cookies.api_token non valido:", err);
    }
  }

  // 2) Login e ruoli dal prop apiToken
  if (apiToken) {
    let decodedApi;
    try {
      decodedApi = jwt_decode(apiToken);
    } catch (err) {
      console.error("apiToken non valido:", err);
      setIsLogged(false);
      // Non proseguire se il token è malformato
      decodedApi = null;
    }

    if (decodedApi) {
      setIsLogged(true);
      setOperator(decodedApi.role?.includes("OPERATOR") ?? false);
      setDelegate(decodedApi.role?.includes("DELEGATE") ?? false);
      setCitizen(decodedApi.role?.includes("CITIZEN") ?? false);
      // Se è delegate, forzo operator = false
      if (decodedApi.role?.includes("DELEGATE")) {
        setOperator(false);
      }
    }
  } else {
    setIsLogged(false);
    setOperator(false);
    setDelegate(false);
    setCitizen(false);
  }

  // 3) Se esiste user_profile e non ho ancora invocato Repo.getUserInfo
  if (cookies.user_profile && !userStatus && cookies.api_token) {
    Repo.getUserInfo(cookies.api_token)
      .then((response) => {
        setUserDataStatus(!response.data);
        setUserStatus(true);
      })
      .catch((error) => {
        console.error("Errore getUserInfo:", error);
        setUserDataStatus(false);
        setUserStatus(false);
      });
  }
}, [
  cookies.api_token,
  cookies.user_profile,
  apiToken,
  userData,
  userStatus,
]);


  let interval;
  useEffect(() => {
    interval = setInterval(() => {
      localStorage.clear();
      window.location.href = subfolder + "/";
    }, 32400000);
  }, [interval]);

  const listaLinkUser = [
    { testo: "Home", url: "/" },
   { testo: "Profilo", url: "/profilo" },
    { testo: "Supporto", url: "/supporto" },
  ];

  const listaLinkDelegate = [
    { testo: "Home", url: "/" },
    { testo: "Utenti", url: "/lista_utenti" },
  ];

  const listaLinkOperator = [
    { testo: "Home", url: "/" },
    { testo: "ISEE", url: "/lista_ISEE" },
    { testo: "Utenti", url: "/lista_utenti" },
    { testo: "Pagamenti", url: "/pagamenti" },
    { testo: "Servizi", url: "/servizi" },
    { testo: "Lista Bandi", url: "/lista_bandi" },
    { testo: labels.flussimypay, url: "/flussi_mypay" },
    { testo: "Aggiornamenti", url: "/gestione_aggiornamenti" },
    {
      testo: "Sistema",
      children: [
        { testo: "Fasce", url: "/fasce" },
        { testo: "Configurazione", url: "/configurazione" },
        { testo: "Report", url: "/report" },
        { testo: "Statistiche", url: "/statistiche" },
      ],
    },
  ];
  const listaLink = [{ testo: "Home", url: "/" }];

  const returnlink = () => {
    if (citizen) {
      return listaLinkUser;
    } 
    else if (delegate) {
      return listaLinkDelegate;
    } 
    else if (operator) {
      return listaLinkOperator;
    } 
    else {
      return listaLink;
    }
  };

  useEffect(() => {
    const handleScrollButtonVisibility = () => {
      window.pageYOffset > 300 ? setShowButton(true) : setShowButton(false);
    };

    window.addEventListener("scroll", handleScrollButtonVisibility);

    return () => {
      window.removeEventListener("scroll", handleScrollButtonVisibility);
    };
  }, []);

  return (
    <div className={`App${sidebarMenuEnabled ? " sidebar-menu-on" : ""}`}>
      {showButton && (
        <a className="backToTop" onClick={() => window.scrollTo(0, 0)}>
          <svg style={{ marginTop: "8px" }} className="icon icon-white">
            <use href={`${iconSprite}#it-arrow-up`}></use>
          </svg>
        </a>
      )}
      <TokenContext.Provider value={apiToken}>
        <BackButtonHandler />
        <Router {...(subfolder && { basename: subfolder })}>
          <div className="headerCustom">
            <MemoizedHeader
              Name={user}
              url="https://www.comune.bari.it/"
              Title={labels.titolo}
              links={returnlink()}
              subfolder={subfolder ? subfolder : ""}
              sidebarMenu={sidebarMenuEnabled}
              sidebarOpen={sidebarOpen}
              onToggleSidebar={toggleSidebar}
            />
          </div>
          {sidebarMenuEnabled ? (
            <div className="app-with-sidebar">
              <Sidebar
                links={returnlink()}
                isOpen={sidebarOpen}
                onClose={closeSidebar}
              />
              <Body
                userDataStatus={userDataStatus}
                subfolder={subfolder ? subfolder : ""}
              ></Body>
            </div>
          ) : (
            <Body
              userDataStatus={userDataStatus}
              subfolder={subfolder ? subfolder : ""}
            ></Body>
          )}

          {isLogged ? <FooterSmall /> : <MemoizedFooter />}
        </Router>
      </TokenContext.Provider>
    </div>
  );
}

export default App;
